import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import GradeMapCourse from "./routes/GradeMapCourse";

export default store => ({
  path: ":departmentId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "grade-map-department-details" */ "./components"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;

      return component;
    })
  ),
  childRoutes: [GradeMapCourse(store)],
});
